// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zgsT","colMin":"styles_colMin__1w3u_"};